import { render } from "./SnakeGame.vue?vue&type=template&id=079392e0&scoped=true"
import script from "./SnakeGame.vue?vue&type=script&lang=js"
export * from "./SnakeGame.vue?vue&type=script&lang=js"

import "./SnakeGame.vue?vue&type=style&index=0&id=079392e0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-079392e0"]])

export default __exports__